
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__p__/[slug]/[id]",
      function () {
        return require("private-next-pages/__p__/[slug]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__p__/[slug]/[id]"])
      });
    }
  